import { Column, Row, Space } from 'farmhub-ui-core';

import { BorderLeft, Wrapper } from './styles';

const WrapperChildTable = ({
  children,
  paddingLeft,
  disabled = false,
}: {
  children?: React.ReactNode;
  paddingLeft?: string;
  disabled?: boolean;
}): JSX.Element => (
  <Wrapper>
    {disabled ? (
      <Row height="100%" width="100%">
        <Column>{children}</Column>
      </Row>
    ) : (
      <Row
        height="100%"
        styles={{
          'padding-left': paddingLeft
            ? `calc(${paddingLeft} + 16px)`
            : 'calc(2% + 16px)',
        }}
        width="100%"
      >
        <BorderLeft />
        <Space width={24} />
        <Column>{children}</Column>
      </Row>
    )}
  </Wrapper>
);

export default WrapperChildTable;
